import { EntityData, initialEntityData } from '@new/common/utils/entity-data';
import { Exam } from '../../../lib/types';

export interface ExamsStateModel {
  items: EntityData<Exam[]>;
  selectedIds: string[];
}

export const examsStateDefaults: ExamsStateModel = {
  items: initialEntityData(),
  selectedIds: []
};
